/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionActionConfigSettings_org = {
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionColors_org" | "SuggestionActionSlack_org" | "SuggestionActionTravelTime_org">;
    readonly " $refType": "SuggestionActionConfigSettings_org";
};
export type SuggestionActionConfigSettings_org$data = SuggestionActionConfigSettings_org;
export type SuggestionActionConfigSettings_org$key = {
    readonly " $data"?: SuggestionActionConfigSettings_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionConfigSettings_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionActionConfigSettings_org",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionActionColors_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionActionSlack_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionActionTravelTime_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'cef41bf24b8aa31048f19118202a8c36';
export default node;
